import Icon from './Icon'
import SkillPill from './SkillPill'
import { skillPalette, skillTypeIcon } from './sourceVisuals'
import styles from './SkillsTab.module.css'

/**
 * SkillsTab — the "Skills" tab on the case detail page. Lists the skills
 * relevant to this ticket (from its REQUIRES_SKILL edges), each with a
 * type-colored icon, name, type pill, and the reason that skill applies to
 * this ticket.
 *
 * Props:
 *   skills {Array<{name, type, reason}>}
 */
export default function SkillsTab({ skills = [] }) {
  if (!skills.length) {
    return <p className={styles.empty}>No skills recorded for this ticket.</p>
  }

  return (
    <div className={styles.list}>
      {skills.map((skill, i) => {
        const palette = skillPalette(skill.type)
        return (
          <div className={styles.card} key={`${skill.name}-${i}`}>
            <span
              className={styles.iconBadge}
              style={{ color: palette.text, borderColor: palette.border, backgroundColor: palette.bg }}
            >
              <Icon name={skillTypeIcon(skill.type)} />
            </span>
            <div className={styles.body}>
              <div className={styles.header}>
                <span className={styles.name}>{skill.name}</span>
                {skill.type && <SkillPill label={skill.type} variant={skill.type.toLowerCase()} />}
              </div>
              {skill.reason && <p className={styles.reason}>{skill.reason}</p>}
            </div>
          </div>
        )
      })}
    </div>
  )
}
